// src/lib/tripStore.js
import { writable } from 'svelte/store';

// Initialize the trip store with an empty array
export const trip = writable([]);
